var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "blocks_details"
  }, [_c('div', [_vm._m(0), !_vm.fetchedUniq ? _c('div', {
    staticClass: "pagination"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.isTopBlock
    },
    on: {
      "click": _vm.previousPage
    }
  }, [_c('fa', {
    attrs: {
      "icon": "chevron-left"
    }
  })], 1), _c('button', {
    attrs: {
      "disabled": _vm.isBottomBlock
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_c('fa', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1)]) : _vm._e(), _vm.blocks.length > 0 ? [_c('EVMBlocks', {
    attrs: {
      "blocks": _vm.blocks
    }
  })] : [_c('Loader', {
    attrs: {
      "content-id": "",
      "message": 'Fetching Blocks'
    }
  })], !_vm.fetchedUniq ? _c('div', {
    staticClass: "pagination"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.isTopBlock
    },
    on: {
      "click": _vm.previousPage
    }
  }, [_c('fa', {
    attrs: {
      "icon": "chevron-left"
    }
  })], 1), _c('button', {
    attrs: {
      "disabled": _vm.isBottomBlock
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_c('fa', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1)]) : _vm._e()], 2), !_vm.loader ? _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "limit_container"
  }, [_c('v-radio-group', {
    staticClass: "limit_container_group",
    attrs: {
      "id": "limit_block",
      "items": _vm.blocksOffsets,
      "label": "Limit",
      "dark": _vm.$root.theme === 'night' ? true : false,
      "dense": ""
    },
    model: {
      value: _vm.blocksOffset,
      callback: function callback($$v) {
        _vm.blocksOffset = $$v;
      },
      expression: "blocksOffset"
    }
  }, [_vm._l(_vm.blocksOffsets, function (item, index) {
    return [_c('v-radio', {
      key: index,
      attrs: {
        "label": item.toString(),
        "value": item,
        "dark": _vm.$root.theme === 'night' ? true : false
      }
    })];
  })], 2)], 1)]) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "headers"
  }, [_c('h2', [_vm._v("Blocks")])]);
}]

export { render, staticRenderFns }